import { Switch, withStyles } from "@material-ui/core"

const AntSwitch = withStyles((theme) => ({
	root: {
		width: 41,
		height: 18,
		padding: 0,
		display: "flex",
	},
	switchBase: {
		padding: 3,
		color: theme.palette.grey[500],
		"&$checked": {
			transform: "translate(24px, 0px)",
			color: theme.palette.common.white,
			"& + $track": {
				opacity: 1,
				backgroundColor: theme.palette.primary.main,
				borderColor: theme.palette.primary.main,
			},
		},
	},
	thumb: {
		width: 12,
		height: 12,
		boxShadow: "none",
	},
	track: {
		border: `1px solid ${theme.palette.grey[500]}`,
		borderRadius: 16 / 2,
		opacity: 1,
		backgroundColor: theme.palette.common.white,
	},
	checked: {},
}))(Switch)

const SwitchControl = ({ state = false, setState = () => {}, name = "name", ...props }) => {
	return <AntSwitch checked={state} onChange={(e) => setState((prev) => e.target.checked)} name={name} {...props} />
}

export default SwitchControl
